<template>
    <div
        class="list-client__container"
    >
        <modal
                v-show="isModal"
                @close="closeModal"
        >
            <template v-slot:modalBody>
                <form-add-client-list
                        v-if="isModal"
                        :values="notInClients"
                        @submitForm="onSubmitClientAdd"
                        @cancelForm="closeModal"
                />
            </template>
        </modal>
        <button
                v-if="canChange"
                class="list-client__item list-client__item_pointer"
                @click="getNotInClients"
        >
            Добавить клиента
        </button>
        <dropdown
                v-if="selectedYear"
                title="Год"
                :items="getYearList()"
                :selectedItems="[selectedYear]"
                :isManyItems="false"
                :width="'220px'"
                :height="'44px'"
                :prompt="'Выберите значение'"
                @onChange="onChangeYear($event)"
        />
        <table-settings
                v-if="canChange"
                :labels="labels"
                :rows="clientsBuffer"
                :isPreloader="isPreloader()"
                :columnSettings="columnSettings"
                :isActionButtons="true"
                :filterFields="['name', 'id']"
                :filterInputBackgroundColor="'#fff'"
                @editedCellInput="onChangeModel"
                @changeDropdown="onChangeUserLinks"
                @removeRow="removeClientFromYear"
                @onFilterChange="onFilterChange"
        >

        </table-settings>
        <card
                :title="'Клиенты'"
                :isPreloader="isPreloader()"
                :isHover="false"
                v-if="!canChange"
        >
            <template v-slot:cardBody>
                <div
                        v-for="(clientItem, clientIndex) in clientList"
                        :key="clientIndex"
                >
                    <button
                            class="list-client__item"
                    >
                        {{clientItem.name}}
                    </button>
                </div>
            </template>
        </card>

    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import serviceApi from "../../services/serviceApi";
import Modal from '../../components/Base/Modal';
import Card from '../../components/Base/Card';
import schemeApi from '../../schemes/schemeApi';
import serviceAuth from "../../services/serviceAuth";
import TableSettings from "../../components/Tables/TableSettings";
import schemeSettingsUserClients from '../../schemes/schemeSettingsUserClients';
import Dropdown from "../../components/Base/Dropdown";
import FormAddClientList from "../../components/Forms/FormAddClientList";
let {
    routeClientList,
    routeClientEditYear,
    routeClientAddLinks,
    routeUserClientSettings,
    routeClientGetNewYear,
    routeClientRemoveYear
} = schemeApi;
let {columnSettings, labels} = schemeSettingsUserClients;
export default {
    name: 'ViewSettingsUserClients',
    components: {
        FormAddClientList,
        TableSettings,
        Modal,
        Card,
        Dropdown
    },
    /**
     * Данные компонента
     * @property {array} clientList - список клиентов
     * @property {array} managerList - список менеджеров
     * @property {boolean} isEmptyClients проверка ответа на пустоту списка клиентов
     * @property {boolean} isEmptyUsers проверка ответа на пустоту списка пользователей
     * @property {boolean} isModal флаг открытия модального окна
     * @property {boolean} isGettingList флаг получения списка клиентов
     * @property {boolean} isGettingUserList флаг получения списка пользователей
     * @property {boolean} isUpdatingList флаг внесения изменений в список
     * @property {boolean} canChange флаг разрешения на возможность редактировать
     * @property {Object} notInClients список клиентов которых нет в этом году
     */
    data: () => ({
        clientList: [],
        isEmptyClients: false,
        isModal: false,

        isGettingList: false,
        isUpdatingList: false,
        canChange: false,

        clients: [],
        links: [],
        managers: [],
        columnSettings: columnSettings,
        labels: labels,
        selectedYear: null,
        notInClients: {},
        clientsBuffer: []
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
    },
    mounted() {
        this.selectedYear = String((new Date()).getFullYear());
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Клиенты и менеджеры");
        // получаем право на редактирование
        this.canChange = serviceAuth.checkPermission(this.activeProjectId, 'change_settings');
        this.getData();
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        getData(){
            if(this.canChange){
                this.getAdminData();
            }else{
                this.getClients();
            }
        },
        /**
         * запрос на получение списка клиентов
         * @async
         */
        async getClients() {
            this.isGettingList = true;
            try {
                let {data = []} = await serviceApi.post(routeClientList, {year: this.selectedYear});
                if(!data.length){
                    this.isEmptyClients = true;
                }
                this.clientList = data;
                this.clientsBuffer = data;
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
            this.isGettingList = false;
        },

        onFilterChange(filterFields) {

            const filteredClients = Object.keys(filterFields).reduce((acc, field) => {
                if(field === 'name'){
                    return acc.filter(client => client[field].toLowerCase().includes(filterFields[field].toLowerCase()))
                }

                if(field === 'id'){
                    const managerList = Object.keys(this.columnSettings).includes(field)
                        && Object.keys(this.columnSettings[field]).includes('values')
                          ? this.columnSettings[field].values
                          : [];

                    const filteredManagerIds = Object.keys(managerList).filter((managerId) => {
                        return this.columnSettings[field].values[managerId].toLowerCase().includes(filterFields[field].toLowerCase())
                    })

                    const managerSelectedList = Object.keys(this.columnSettings).includes(field)
                      && Object.keys(this.columnSettings[field]).includes('selected')
                        ? this.columnSettings[field].selected
                        : [];

                    const rowIds = Object.keys(managerSelectedList).filter((rowId) => {
                        const rowManagersSelected = Object.keys(managerSelectedList).includes(rowId)
                            ? managerSelectedList[rowId]
                            : [];

                        if(!rowManagersSelected.length || !filteredManagerIds.length){
                            return false
                        }

                        const hasIntersection = (arr1, arr2) => {
                          const set1 = new Set(arr1);
                          return arr2.some(item => set1.has(item));
                        };

                        return hasIntersection(rowManagersSelected, filteredManagerIds)
                    })

                    return acc.filter(client => rowIds.includes(client[field]))
                }
                return acc;
            }, this.clients)

            this.clientsBuffer = filteredClients
        },
        /**
         * запрос на удаление строки
         * @async
         */
        async removeClientFromYear(row){
            try {
                await serviceApi.post(
                    routeClientRemoveYear,
                    {year: this.selectedYear, client_id: row.id}
                    );
                this.getData();
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
        },
        /**
         * запрос на списка менеджеров
         * @async
         */
        async getAdminData() {
            this.isGettingList = true;
            try {
                let {data = {}} = await serviceApi.post(routeUserClientSettings, {year: this.selectedYear});
                console.log(data);
                this.clients = data.clients;
                this.clientsBuffer = data.clients;
                this.columnSettings.id.selected = data.links;
                this.columnSettings.id.values = data.managers;
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
            this.isGettingList = false;
        },
        isPreloader(){
            return this.isUpdatingList || this.isGettingList;
        },
        /**
         * событие закрытие модального окна добавления клиента
         */
        closeModal() {
            this.isModal = false;
        },
        /**
         * событие добавления имени нового клиента
         * @param {string} clientId - id нового клиента
         */
        onSubmitClientAdd(clientId) {
            this.closeModal();
            this.postAddClient(clientId);
        },
        /**
         * запрос на добавление нового клиента
         * @param {string} clientId - id нового клиента
         *
         * @async
         */
        async postAddClient(clientId) {
            this.isUpdatingList = true;
            try {
                let {data = []} = await serviceApi.post(routeClientEditYear, {year: this.selectedYear, client_id: clientId});
                if(data.message){
                    // alert(data.message);
                }
                if (data.error){
                    alert(data.error);
                }else{
                    this.getData();
                }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isUpdatingList = false;
        },
        /**
         * запрос на получение клиентов которых нет в текущем годе
         *
         * @async
         */
        async getNotInClients() {
            try {
                let {data = {}} = await serviceApi.post(routeClientGetNewYear, {year: this.selectedYear});
                let {new_clients = {}} = data;
                this.notInClients = new_clients;
                this.isModal = true;
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
        },
        /**
         * запрос на редактирование модели
         * @async
         * @property {array} client - редактируемый клиент
         */
        async onChangeModel(client){
            let postData = {
                client_id: client['id'],
                editAttribute: client['attribute'],
                editValue: client['value'],
                year: this.selectedYear
            };
            this.isUpdatingList = true;
            try {
                let {data = []} = await serviceApi.post(routeClientEditYear, postData);
                if(data.message){
                    // alert(data.message);
                }
                if (data.error){
                    alert(data.error);
                }else{
                    this.getAdminData();
                }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isUpdatingList = false;
        },
        /**
         * запрос на добавление менеджеров к клиенту
         * @async
         * @property {object} data - клиент и выбранные user_ids
         */
        async onChangeUserLinks(data){
            let postData = {
                client_id: data.row[data.attribute],
                user_ids: data.selected,
                year: this.selectedYear
            }
            try {
                let {data = []} = await serviceApi.post(routeClientAddLinks, postData);
                if(data.message){
                    // alert(data.message);
                }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
        },
        /**
         * Событие выбора года
         * @property {array} data - выбранный год
         */
        onChangeYear(data){
            this.selectedYear = data[0];
            this.getData();
        },
        /**
         * Получение значений годов для выпадашки
         */
        getYearList(){
            var now = new Date();
            var cur_year = now.getFullYear();
            let years = {};
            years[String(cur_year - 1)] = String(cur_year - 1);
            years[String(cur_year)] = String(cur_year);
            years[String(cur_year + 1)] = String(cur_year + 1);
            return years
        },
    }
}
</script>

<style lang="scss" scoped>
    .list-client__container {
        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
        -webkit-box-flex: 1;
    }
    .list-client__item{
        border-radius: 10px;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        padding: 10px;
    }
    .list-client__item_pointer{
        cursor: pointer;
    }
    .list-client__item_active{
        background: #dcdcdc;
    }
</style>